import { lazy } from 'react';

// Har bir rol kabineti alohida chunk bo'lib yuklanadi (asosiy bundle kattalashmasligi uchun).
export const ROLE_MODULES = {
  director: lazy(() => import('./director')),
  admin: lazy(() => import('./admin')),
  head_of_department: lazy(() => import('./head_of_department')),
  registrar: lazy(() => import('./registrar')),
  methodist: lazy(() => import('./methodist')),
  editor: lazy(() => import('./editor')),
  qc_expert: lazy(() => import('./qc_expert')),
  proctor: lazy(() => import('./proctor')),
  curator: lazy(() => import('./curator')),
  admissions: lazy(() => import('./admissions')),
  finance: lazy(() => import('./finance')),
  chief_accountant: lazy(() => import('./chief_accountant')),
  internal_control: lazy(() => import('./internal_control')),
  corporate_hr: lazy(() => import('./corporate_hr')),
};
